<template>
  <section class="sectioncarddiv">
    <div class="card shadow carddiv"  :class="{'agoalcss': agoalstheme==='goalcss' || 'agoalcss'}">
      <div v-html="toptextinfo" class="toptextinfocss"></div>
      <div style="text-align: center;padding-top: 10px; font-weight: bold; font-size: 18px;">
        <a :href="cmesglink" style="text-decoration: none;">{{ cmitesglinktext }}</a>
      </div>
      <div class="row " >
        <div :class="`col-xs-12 col-sm-12 col-md-${catnum}`" v-for="(agoal, index) in getagoals" :key="index">
          <!-- <div class="card"> -->
            <a href="#" @click="$emit('getId', $event.target.value=agoal.gcid)">
              <img class="card-img-top shadow mycards" :src="`${imagepath}${agoal.agoalimage}`" alt="Card image cap"  data-bs-toggle="modal" data-bs-target="#exampleModal">
            </a>
          <!-- </div> --> 
        </div>
      </div>
      <!-- Modal -->
      <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="diplayunit" v-html="getgoaldetails" v-if="firstgoalid > 1">
              </div>
              <div class="diplayunit" v-html="firstgoal" v-else>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
      
    </div>
  </section>

   
</template>
  
  <script>
  export default{
  props: ['getagoals', 'getgoaldetails', 'firstgoal', 'firstgoalid', 'imagepath', 
  'agoalstheme', 'toptextinfo', 'cmitesglinktext', 'cmesglink', 'catnum'],
  data(){ 

  },
  methods: {
    getId() {
      this.$emit('getgoalId', $event.target.value)
    }
  }
  }
  </script>
  
  <style scoped>
  /*===================MEDIA SCREENS TAMPLATES===============*/
   /* Extra small devices (phones, 600px and down) */

   .card-img-top {
    border-radius: 7px;
   }
   .diplayunit {
    margin-top: 30px;
   }
   .carddiv {
    padding: 50px;
    padding-bottom: 30px;
    margin-bottom: 40px;
    background-color: whitesmoke;
  }
  .sectioncarddiv {
    background-color: antiquewhite;
    padding-top: 50px;
    padding-bottom: 50px;
  }
   @media only screen and (max-width: 600px) {
 
    .carddiv {
      margin-top: 100px;
    }
    .diplayunit {
      padding: 20px;
    }
    .card {
      max-width: 100%;
      margin-top: 20px;
    }
    .col-sm-12 {
      padding-left: 60px;
      padding-right: 60px;
    }
    .sectioncarddiv {
      padding-left: 20px;
      padding-right: 20px;
    }
  
   }
  
   /* Small devices (portrait tablets and large phones, 600px and up) */
   @media only screen and (min-width: 600px) {
    .carddiv {
      margin-top: 100px;
    }
    .diplayunit {
      padding: 20px;
    }
    .card {
      max-width: 100%;
      margin-top: 20px;
    }
    .col-sm-12 {
      padding-left: 140px;
      padding-right: 140px;
    }
    .sectioncarddiv {
      padding-left: 20px;
      padding-right: 20px;
    }
  
  
   }
   img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    background-color: #003;
  }
   /* Medium devices (landscape tablets, 768px and up) */
   @media only screen and (min-width: 768px) {
    .col-sm-12 {
      padding-left: 20px;
  
      margin-top: 30px;
    }
   }
  
   
   /* Large devices (laptops/desktops, 992px and up) */
   @media only screen and (min-width: 992px) {
    .carddiv {
      width: 70%;
      margin-left: 200px;
    }
    .col-sm-12 {
      padding-left: 20px;
      padding-right: 20px;
      margin-top: 30px;
    }
  
   }
   
   /* Extra large devices (large laptops and desktops, 1200px and up) */
   @media only screen and (min-width: 1200px) {
    .col-sm-12 {
      padding-left: 20px;
      padding-right: 20px;
      margin-top: 30px;
    }
  }
  
/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1400px) {
  
}
  
    /* Extra large devices (large laptops and desktops, 1200px and up) */
    @media only screen and (min-width: 1600px) {

  }
   
  </style>